// extracted by mini-css-extract-plugin
module.exports = {"actionCell":"tableAction__actionCell___25ZQO"};